import './Loader.css'

/**
 * Лоадер с крутящимся кружком слева от текста.
 * @param {string} [text] - Текст справа (например "Loading...", "Saving...")
 * @param {boolean} [inline] - Компактный вариант для кнопок (inline flex)
 */
export default function Loader({ text = 'Loading...', inline = false }) {
  return (
    <span className={`loader ${inline ? 'loader-inline' : ''}`}>
      <span className="loader-spinner" aria-hidden />
      {text && <span className="loader-text">{text}</span>}
    </span>
  )
}
